module.exports = __webpack_public_path__ + "ab43ff70dc32068c31ef1591809007da.png";